import React from 'react';
import './Chapters.scss';

function Chapter5() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        “Because of the cloud technology we have with AWS, coupled with the security and power of
        Intel<sup>®</sup>Xeon<sup>®</sup> Scalable processors and what we’ve implemented, we’re able
        to stand up an entire facility in the cloud—networking, security, storage, every part of
        it—within 15 minutes,” Keske says.
      </p>
      <p className="chapter__paragraph">
        In 2022, Company 3 has completed 20 projects with AWS—all of which would have been either
        impossible or significantly more expensive to achieve on premises.
      </p>
    </section>
  );
}

export default Chapter5;
